'use strict';

angular.module('myConsultApp').directive('zoetisPagination', function ($timeout) {
  return {
    templateUrl: 'templates/zoetisPagination.html',
    restrict: 'E',
    scope: {
      pageData: '=',
      objKey: '@objKey',
      gotoPageFn: '&',
      pageSize: '@pageSize',
    },
    link: function (scope, elem, attr) {
      console.log(scope.pageData);
      if (scope.pageSize == undefined || scope.pageSize == null) {
        scope.pageSize = 10;
      }
      scope.pagination = {};

      scope.getShowingText = function (data, pagination) {
        var length = data.length;
        var count = pagination.count;
        var currentPage = pagination.current_page;
        var startNumber = 0;
        if (currentPage == 1) {
          startNumber = 1;
        } else if (pagination.next == null) {
          startNumber = count - length + 1;
        } else {
          startNumber = (currentPage - 1) * length + 1;
        }

        var endNumber = startNumber + length - 1;
        if (count == 0) {
          startNumber = 0;
          endNumber = 0;
        }

        return 'Showing ' + startNumber + '-' + endNumber + ' of ' + count + ' items';
      };

      scope.getPageNumberUrl = function (name, url, prev, num) {
        var adjust = -1;
        if (url == null && prev != null) {
          url = prev;
          adjust = 1;
        }
        if (!url && !prev) {
          return null;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
        if (!results) return url;
        if (!results[2]) return '';
        return url.replace(/(page=)[^\&]+/, '$1' + num);
      };

      scope.getPages = function (data) {
        var config = {
          startPage: 1,
          itemsOnPage: scope.pageSize,
          displayPages: 3,
          edges: 2,
        };
        var pagination = {
          currentPage: data.meta.current_page,
          showingText: scope.getShowingText(data[scope.objKey], data.meta),
          itemCount: data.meta.count,
          pageCount: Math.ceil(data.meta.count / config.itemsOnPage),
          beginningElipses: false,
          endingElipses: false,
          displayedPages: [],
          next: data.meta.next,
          previous: data.meta.previous,
        };

        if (
          pagination.currentPage - 1 > config.displayPages ||
          (pagination.currentPage - 1 > 1 &&
            pagination.pageCount > config.displayPages + config.edges)
        ) {
          pagination.beginningElipses = true;
        }

        if (
          pagination.pageCount - pagination.currentPage > config.displayPages + config.edges ||
          (pagination.pageCount - pagination.currentPage > 2 &&
            pagination.pageCount > config.displayPages + config.edges)
        ) {
          pagination.endingElipses = true;
        }

        function getDisplayedPages() {
          var pages = [];

          if (pagination.itemCount == 0) {
            pages.push({
              number: 0,
              url: '',
            });
            return pages;
          }

          // Push First Page
          pages.push({
            number: config.startPage,
            url: scope.getPageNumberUrl(
              'page',
              pagination.next,
              pagination.previous,
              config.startPage,
            ),
          });

          // Check for beginingElipses
          if (
            pagination.currentPage - 1 > config.displayPages ||
            (pagination.currentPage - 1 > 2 &&
              pagination.pageCount > config.displayPages + config.edges)
          ) {
            pages.push({
              number: '...',
              url: null,
            });
          }

          // Push Displayed Pages
          var startIndex, endIndex;
          if (
            pagination.currentPage == config.startPage ||
            pagination.currentPage == config.startPage + 1
          ) {
            startIndex = config.startPage + 1;
          } else if (
            pagination.currentPage == pagination.pageCount ||
            pagination.currentPage == pagination.pageCount - 1
          ) {
            startIndex =
              pagination.currentPage > config.displayPages
                ? pagination.currentPage - 2
                : config.startPage + 1;
          } else {
            startIndex = pagination.currentPage - 1;
          }

          if (
            pagination.currentPage == pagination.pageCount ||
            pagination.currentPage == pagination.pageCount - 1
          ) {
            endIndex =
              startIndex + config.displayPages < pagination.pageCount
                ? startIndex + config.displayPages
                : pagination.pageCount;
          } else if (startIndex + config.displayPages > pagination.pageCount) {
            endIndex = pagination.pageCount;
          } else if (startIndex == pagination.pageCount) {
            endIndex = startIndex + 1;
          } else {
            endIndex = startIndex + config.displayPages;
          }

          for (var i = startIndex; i < endIndex; i++) {
            var page = {
              number: i,
              url: scope.getPageNumberUrl('page', pagination.next, pagination.previous, i),
            };
            pages.push(page);
          }

          // Check for endingElipses
          if (
            pagination.pageCount - pagination.currentPage > config.displayPages + config.edges ||
            (pagination.pageCount - pagination.currentPage > 2 &&
              pagination.pageCount > config.displayPages + config.edges)
          ) {
            pages.push({
              number: '...',
              url: null,
            });
          }

          // Push Last Page
          if (config.startPage != pagination.pageCount) {
            pages.push({
              number: pagination.pageCount,
              url: scope.getPageNumberUrl(
                'page',
                pagination.next,
                pagination.previous,
                pagination.pageCount,
              ),
            });
          }

          return pages;
        }

        pagination.displayedPages = getDisplayedPages();

        return pagination;
      };

      scope.goToPage = function (url) {
        if (url) {
          scope.gotoPageFn({ url: url });
        }
      };

      scope.$watch('pageData', function () {
        if (scope.pageData != undefined && Object.keys(scope.pageData).length > 0) {
          scope.pagination = scope.getPages(scope.pageData);
        }
      });
    },
  };
});
